document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-review-section]').forEach(function (container) {
    var swiperEl = container.querySelector('.review-swiper');
    var paginationEl = container.querySelector('.review-pagination');
    if (!swiperEl) return;

    new Swiper(swiperEl, {
      slidesPerView: 1,
      spaceBetween: 0,
      pagination: {
        el: paginationEl,
        clickable: true
      },
      autoplay: {
        delay: 3000,
        disableOnInteraction: false
      }
    });
  });

  var reviewTarget = document.getElementById('judgeme_product_reviews');
  if (reviewTarget) {
    document.querySelectorAll('.total-review').forEach(function (el) {
      el.addEventListener('click', function () {
        reviewTarget.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }
});
